import { accountingApi } from '@/api'

export const checkIntegrationStatus = companyId => accountingApi.get(`/apideck/api/v1/vault/integration/${companyId}`) // notIntegrated | disconnected | pending | connected

export const accountingOnboard = payload => accountingApi.post(`/apideck/api/v1/vault/integration`, payload)

export const disconnectAccountingSoftware = companyId => accountingApi.delete(`/apideck/api/v1/vault/integration/${companyId}`)

export const getShortTermCashflow = companyId => accountingApi.get(`/dashboard/api/v1/cashflow/${companyId}/shortterm`)

export const getCashflowForecast = ({ companyId, selectedHistory, selectedForecast }) =>
  accountingApi.get(`/dashboard/api/v1/cashflow/${companyId}?actualMonthAmounts=${selectedHistory}&forecastMonthAmounts=${selectedForecast}`)
